import { render } from "./roomDataList.vue?vue&type=template&id=35e36e98&scoped=true"
import script from "./roomDataList.vue?vue&type=script&lang=js"
export * from "./roomDataList.vue?vue&type=script&lang=js"

import "./roomDataList.vue?vue&type=style&index=0&id=35e36e98&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e36e98"]])

export default __exports__